import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import { MdDarkMode, MdLightMode, MdSatelliteAlt } from 'react-icons/md';
import { cycleTheme, themeToggleTitle } from '../basemap/tileConfig';

export default function ThemeToggleButton({ theme, onChange, className = 'theme-toggle-button', placement = 'left' }) {
  const Icon = theme === 'satellite' ? MdSatelliteAlt : (theme === 'dark' ? MdLightMode : MdDarkMode);
  return (
    <AntTooltip title={themeToggleTitle(theme)} placement={placement}>
      <button type="button" className={className} onClick={() => onChange(cycleTheme(theme))}>
        <Icon />
      </button>
    </AntTooltip>
  );
}
